'use client';

import { LogOut } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

export default function LogoutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/auth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

      logout(); // șterge tokenul și actualizează contextul

      navigate('/login', { replace: true }); // redirect fără reload
    } catch (error) {
      console.error("Eroare la logout:", error);
    }
  };

  return (
    
      <button
        onClick={handleLogout}
        className="w-full flex items-center px-3 py-3 text-left text-red-600 hover:bg-red-50 rounded-xl transition-colors duration-200"
      >
        <LogOut className="w-5 h-5" />
        <span className="ml-3 font-medium">Deconectare</span>
      </button>
    
  );
}
